export const replaceInstallationName = text => {
  if (typeof text !== 'string') return text;

  const installationName = window.globalConfig?.INSTALLATION_NAME;
  return installationName ? text.replace(/Chatwoot/g, installationName) : text;
};
